import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

export default function RatingStar(props: any) {
  const { score, notext = false } = props;
  let rating = Number(score);

  let halfStar = null;
  let halfCount = 0;

  if (Number(score) > 5) rating = 5;
  if (Number(score) < 0) rating = 0;

  // 不是整数时
  if (!Number.isInteger(rating)) {
    rating = Math.floor(rating);
    halfCount = 1;
    halfStar = (
      <span className="dbo-ratingstar-half">
        <SvgIcon type="star-action" className="dbo-ratingstar-icon active" />
        <SvgIcon type="star-action" className="dbo-ratingstar-icon" />
      </span>
    );
  }

  return (
    <div className="dbo-ratingstar">
      {[...Array(rating)].map((x, i) => (
        <SvgIcon
          key={i}
          type="star-action"
          className="dbo-ratingstar-icon active"
        />
      ))}
      {halfStar}
      {[...Array(5 - rating - halfCount)].map((x, i) => (
        <SvgIcon key={i} type="star-action" className="dbo-ratingstar-icon" />
      ))}
      {notext ? null : (
        <span className="dbo-ratingstar-text">{Number(score).toFixed(1)}</span>
      )}
    </div>
  );
}
